import {useTranslation} from 'react-i18next';

import {ACTIVITY_ICONS, REQUEST_ACTIVITY_TYPES} from '../activity-presentation';
import {ActivityFeedRowLayout} from '../ActivityFeedRowLayout';
import {ActivityAmountBadge} from './ActivityAmountBadge';
import {castMetadata} from './metadata.utils';

import type {TrustPayoutMetadata, TrustAccountActivityDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface TrustPayoutRowProps {
  activity: TrustAccountActivityDTO;
}

export const TrustPayoutRow: FC<TrustPayoutRowProps> = ({activity}) => {
  const {t} = useTranslation('trustAccounts');
  const meta = castMetadata<TrustPayoutMetadata>(activity);

  return (
    <ActivityFeedRowLayout
      icon={ACTIVITY_ICONS[activity.activityType]!}
      title={t(`view.activity.activityType.${activity.activityType}`)}
      subtitle={meta?.description ?? null}
      actorName={meta?.creditorName ?? null}
      createdAt={activity.createdAt}
      action={
        meta?.amount ? (
          <ActivityAmountBadge
            amount={meta.amount}
            variant="debit"
            pending={REQUEST_ACTIVITY_TYPES.has(activity.activityType)}
          />
        ) : undefined
      }
    />
  );
};
